import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openFullScreenDialog<T, D = any>(component: any, data: D): MatDialogRef<T> {
    console.log(data);
    
    const config: MatDialogConfig<D> = {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'full-screen-dialog',
      data,
    };

    return this.dialog.open<T, D>(component, config);
  }
}
